import { usePostHog } from './posthog'

export function useFeatureFlags() {
  const { posthog } = usePostHog()

  return {
    isMaterialSearchEnabled() {
      return posthog.isFeatureEnabled('is_material_search_enabled')
    },
    isChatAssistantEnabled() {
      return posthog.isFeatureEnabled('is_chat_assistant_enabled')
    },
  }
}
